/**
 * Static Mongolian → English UI dictionary for the AutoTranslator.
 *
 * - Exact-match lookup against trimmed text-node content.
 * - No AI, no network calls. Add new entries here as you find untranslated strings.
 * - Keep keys lowercase-insensitive by also adding casing variants if needed.
 */
export const MN_TO_EN: Record<string, string> = {
  // ===== Global nav / header =====
  'Нүүр': 'Home',
  'Урам': 'Deal',
  'Тэмцээн': 'Competitions',
  'Хэтэвч': 'Wallet',
  'Хяналтын самбар': 'Dashboard',
  'Хэл солих': 'Toggle language',
  'Үнэ': 'Prices',
  'Үнэ цэнэ': 'Value',
  'Үнэ цэнтэй газар': 'Value places',
  'Газрын зураг': 'Map',
  'Яриа': 'Talk',
  'ЭЕШ': 'Exam',
  'Шалгалт': 'Exam',
  'Дасгал': 'Practice',
  'Сорил': 'Mock test',
  'Хөгжил': 'Progress',
  'Дэмжих': 'Support',
  'Дэмжигч': 'Supporter',
  'Тохиргоо': 'Settings',
  'Профайл': 'Profile',
  'Гарах': 'Sign out',
  'Нэвтрэх': 'Sign in',
  'Бүртгүүлэх': 'Sign up',
  'Хадгалсан': 'Saved',
  'Мэдэгдэл': 'Notifications',
  'Хэл': 'Language',
  'Монгол': 'Mongolian',
  'Англи': 'English',

  // ===== Common buttons / actions =====
  'Илгээх': 'Send',
  'Хадгалах': 'Save',
  'Цуцлах': 'Cancel',
  'Үргэлжлүүлэх': 'Continue',
  'Дуусгах': 'Finish',
  'Буцах': 'Back',
  'Дараах': 'Next',
  'Өмнөх': 'Previous',
  'Хайх': 'Search',
  'Шүүлтүүр': 'Filters',
  'Шүүх': 'Filter',
  'Цэвэрлэх': 'Clear',
  'Бүгдийг арилгах': 'Clear all',
  'Дэлгэрэнгүй': 'Details',
  'Илүү': 'More',
  'Бага': 'Less',
  'Нэмэх': 'Add',
  'Засах': 'Edit',
  'Устгах': 'Delete',
  'Баталгаажуулах': 'Confirm',
  'Тийм': 'Yes',
  'Үгүй': 'No',
  'Тэгэх': 'OK',
  'Хаах': 'Close',
  'Үргэлжлэл': 'Continue',
  'Туслах': 'Help',
  'Талархаж байна': 'Thank you',
  'Баярлалаа': 'Thank you',
  'Уучлаарай': 'Sorry',
  'Алдаа гарлаа': 'Something went wrong',
  'Ачаалж байна...': 'Loading...',
  'Ачаалж байна…': 'Loading…',
  'Хүлээж байна...': 'Please wait...',

  // ===== Auth =====
  'И-мэйл': 'Email',
  'Нууц үг': 'Password',
  'Нууц үг сэргээх': 'Reset password',
  'Нууц үгээ мартсан уу?': 'Forgot password?',
  'Дахин илгээх': 'Resend',
  'Шинэ хэрэглэгч үү?': 'New user?',
  'Аль хэдийн бүртгэлтэй юу?': 'Already have an account?',

  // ===== Value Map =====
  'Газар нэмэх': 'Add place',
  'Үнэ нэмэх': 'Add price',
  'Газар хайх': 'Search places',
  'Ойролцоох': 'Nearby',
  'Шинэ': 'New',
  'Шинэхэн': 'Brand new',
  'Топ': 'Top',
  'Хямд': 'Cheap',
  'Дунд': 'Medium',
  'Өндөр': 'High',
  'Үнэ цэнтэй газрыг хамтдаа олъё': "Let's discover great value places",
  'Амтыг хамтдаа': "Let's taste together",
  'Үнэ цэнтэй газрыг хамтдаа олъё.': "Let's discover great value places.",
  'Үдийн хоол': 'Lunch',
  'Кафе': 'Cafe',
  'Талх': 'Bakery',
  'Мах': 'Meat',
  'Эмийн сан': 'Pharmacy',
  'Эмнэлэг': 'Clinic',
  'Бусад': 'Other',
  'Зураг': 'Photo',
  'Зургууд': 'Photos',
  'Сэтгэгдэл': 'Comments',
  'Сэтгэгдэл алга': 'No comments yet',
  'Одоогоор сэтгэгдэл алга': 'No comments yet',
  'Богино туршлагаа бичнэ үү...': 'Write a short experience...',
  'Их таалагдсан': 'Most liked',
  'Шинэ мэдээлэл': 'New updates',
  'Шилдэг': 'Top',
  'Шүүлт': 'Filter',
  'Жагсаалт': 'List',
  'Хоол, газар, дүүргээр хай': 'Search by food, place, district',
  'Эрэмбэ: Шилдэг': 'Sort: Top',
  'Эрэмбэ': 'Sort',
  'Шилдэг үнэ цэнэ': 'Best value',
  'Шилдэг үнэ цэнэтэй': 'Best value',
  'Шилдэг сэтгэгдэл': 'Top comments',
  'Шилдэг хэмнэлт': 'Top savings',
  'Шүүлтэд тохирох газар алга. Шүүлтүүрээ өөрчилж үзээрэй.': 'No places match your filters. Try adjusting them.',
  'Шүүлт цэвэрлэх': 'Clear filters',
  'Олон нийтийн үнэлсэн хямд газруудыг ойроос ол · Сурталчилгаагүй': 'Find community-rated affordable places nearby · Ad-free',
  'Олон нийтээр шинэчлэгддэг газрын зургаас ойролцоох хямд, үнэ цэнтэй газрыг хайгаарай. Сурталчилгаагүй.': 'Discover nearby affordable, valuable places on a community-updated map. Ad-free.',
  'Сурталчилгаагүй': 'Ad-free',
  'Үнэ баталгаажуулсан': 'Price confirmed',
  'Хүлээгдэж байна': 'Pending',
  'Батлагдсан': 'Approved',
  'Татгалзсан': 'Rejected',
  'Үнэ батлах': 'Confirm price',
  'Үнэ буруу': 'Wrong price',
  'Мэдээллийг засах': 'Edit info',
  'Мэдээлэл буруу гэж мэдэгдэх': 'Report wrong info',
  'Хадгалах газар': 'Save place',
  'Зам заах': 'Get directions',
  'Хуваалцах': 'Share',
  'Өөрчлөлтийн түүх': 'Change history',
  'Place edit хүсэлт алга.': 'No place edit requests.',
  'Place edit хүсэлт алга': 'No place edit requests',
  'Зам': 'Route',
  'Дэлгэрэнгүй үзэх': 'View details',
  'Мэдээлэл засах': 'Edit info',
  'Мэдэгдэх': 'Report',
  'Одоо нээлттэй': 'Open now',
  'Баталгаажсан': 'Verified',
  'Шинэ нэмэгдсэн': 'Recently added',
  'Үнэ шинэчлэгдсэн': 'Price updated',
  'Зурагтай': 'With photos',
  'Олон хүн зөвшөөрсөн': 'Community-confirmed',
  'Энэ газрын байршил алга': 'No location for this place',
  'Замыг зурахын тулд байршлаа зөвшөөрнө үү.': 'Please share your location to draw a route.',
  'Газраа сонгоод "Үнэ нэмэх" дарна уу.': 'Pick a place, then tap "Add price".',
  'Шинэ газар': 'New place',
  'Бидний тухай': 'About',
  'Холбоо барих': 'Contact',
  'Тусламж': 'Help',
  'Нууцлал': 'Privacy',
  'Нөхцөл': 'Terms',
  'Күүки': 'Cookies',
  'Улаанбаатар': 'Ulaanbaatar',

  // ===== Talk / community =====
  'Шинэ пост': 'New post',
  'Хэлэлцүүлэг': 'Discussion',
  'Зөвлөгөө': 'Tips',
  'Хямдрал': 'Deals',
  'Асуулт': 'Question',
  'Хариулт': 'Answer',
  'Хариулах': 'Reply',
  'Тайлбар': 'Description',
  'Гарчиг': 'Title',
  'Контент': 'Content',

  // ===== Exam =====
  'Оношилгоо': 'Diagnostic',
  'Дасгалжих': 'Practice',
  'Хичээл': 'Subject',
  'Сэдэв': 'Topic',
  'Асуулт хариулт': 'Q&A',
  'Оноо': 'Score',
  'Тооцоолсон оноо': 'Estimated score',
  'Зөв': 'Correct',
  'Буруу': 'Wrong',
  'Алгасах': 'Skip',
  'Дараагийн': 'Next',
  'Дуусгасан': 'Completed',
  'Үргэлжлэлтэй': 'In progress',
  'Сурах төлөвлөгөө': 'Study plan',
  'Шинжилгээ': 'Analysis',
  'Сулууд': 'Weak areas',
  'Хүчтэй талууд': 'Strengths',

  // ===== Settings / billing =====
  'Үнэ ба багц': 'Pricing & plans',
  'Багц': 'Plan',
  'Стандарт': 'Standard',
  'Плюс': 'Plus',
  'Про': 'Pro',
  'Туршилтын 7 хоног': '7-day trial',
  'Сар бүр': 'Monthly',
  'Жил бүр': 'Yearly',
  'Захиалга': 'Subscription',
  'Захиалах': 'Subscribe',
  'Цуцалсан': 'Cancelled',
  'Идэвхтэй': 'Active',
  'Дуусах огноо': 'Expires',
  'Кредит': 'Credits',
  'Үлдэгдэл': 'Balance',
  'Цэнэглэх': 'Top up',
  'Гүйлгээний түүх': 'Transaction history',

  // ===== Misc =====
  'Тэгш': 'Equal',
  'Бүгд': 'All',
  'Алийг ч сонгоогүй': 'None selected',
  'Үр дүн алга': 'No results',
  'Хоосон': 'Empty',
  'Удахгүй': 'Soon',
  'Шинэчлэгдсэн': 'Updated',
  'Огноо': 'Date',
  'Хэрэглэгч': 'User',
  'Админ': 'Admin',
  'Модераци': 'Moderation',
  'Тайлан': 'Reports',
  'Постууд': 'Posts',
  'Хэлэлцүүлгүүд': 'Discussions',
  'Газрууд': 'Places',
  'Засварууд': 'Edits',
  'Тайлангууд': 'Reports',

  // ===== Donate page =====
  'Олон нийтийн дэмжлэгээр': 'Community-supported',
  'Lavlah-ийг дэмжээрэй': 'Support Lavlah',
  'Lavlah нь сурталчилгаагүй, олон нийтийн дэмжлэгээр ажилладаг.': 'Lavlah is ad-free and runs on community support.',
  'Төлбөртэй жагсаалт, баннер байхгүй.': 'No paid listings or banners.',
  'Хандивлагчид болон сайн дурын хүмүүсээр явдаг.': 'Powered by donors and volunteers.',
  'Чанартай мэдээлэл': 'Quality information',
  'Модерац, баталгаажуулалтад зарцуулагдана.': 'Spent on moderation and verification.',
  'Хүртээмжтэй': 'Accessible',
  'Бүх хүнд нээлттэй, үнэгүй хэрэглээ.': 'Open and free for everyone.',
  'Баярлалаа!': 'Thank you!',
  'Дахин хандивлах': 'Donate again',
  'Төлбөр хүлээж байна': 'Waiting for payment',
  'QR кодыг банкны аппаараа уншуулна уу. Төлбөр хийгдсэний дараа автоматаар баталгаажна.': 'Scan the QR code with your bank app. It will confirm automatically after payment.',
  'Эсвэл банкны апп нээх:': 'Or open a bank app:',
  'Төлбөр шалгах': 'Check payment',
  'Төлбөр хараахан баталгаажаагүй байна': 'Payment not confirmed yet',
  'Хандивын дүн сонго': 'Choose a donation amount',
  'Эсвэл өөрөө дүн оруулах': 'Or enter a custom amount',
  'Жишээ: 25000': 'Example: 25000',
  '"Баталгаажуулах" дарсны дараа QPay QR код гарч ирэх ба банкны аппаараа уншуулан төлнө.': 'After tapping "Confirm" a QPay QR code appears — scan it with your bank app to pay.',
  'Нэр (заавал биш)': 'Name (optional)',
  'Мессеж (заавал биш)': 'Message (optional)',
  'Бат': 'Bat',
  'Сайн ажиллаж байна!': 'Great work!',
  'Миний нэрийг нийтийн хандивлагчдын хуудсанд харуулахыг зөвшөөрнө': 'Show my name on the public donor wall',
  'Үүсгэж байна…': 'Creating…',
  'Хандивлах': 'Donate',
  'Дурын үед зогсоох боломжтой. Бид сар бүр ил тод тайлагнана.': 'Cancel anytime. We report transparently every month.',
  'Дараа нь юу болох вэ?': 'What happens next?',
  'Та хандивлана': 'You donate',
  'Сервер, модерац, AI-д зарцуулагдана': 'Spent on servers, moderation, and AI',
  'Үнэ цэнийн зураг чөлөөтэй, шударга үлдэнэ': 'The value map stays free and fair',
  'Хандив нь татвараас чөлөөлөгдөхгүй болно. Lavlah ашгийн төлөө бус санаачлага.': 'Donations are not tax-deductible. Lavlah is a non-profit initiative.',
  'Хандивлах · Lavlah': 'Donate · Lavlah',
  'Lavlah нь сурталчилгаагүй, олон нийтийн дэмжлэгээр үнэгүй ажилладаг. Биднийг дэмжээрэй.': 'Lavlah is ad-free and runs free on community support. Please support us.',
  'Хандивын дүнг оруулна уу (≥100₮)': 'Please enter a donation amount (≥100₮)',
  'Нэг удаагийн хандивын дээд хязгаар 5,000,000₮. Илүү их хандив өгөх бол холбоо барина уу.': 'Maximum single donation is 5,000,000₮. For larger gifts, please contact us.',
  'QPay нэхэмжлэх үүсгэхэд алдаа гарлаа': 'Failed to create QPay invoice',
  'Баярлалаа! Хандивыг тань хүлээн авлаа.': 'Thank you! Your donation has been received.',

  // ===== Cookie banner =====
  'Бид күүки ашигладаг.': 'We use cookies.',
  'Татгалзах': 'Decline',
  'Зөвшөөрөх': 'Accept',

  // ===== Talk page =====
  'Хэмнэлттэй амьдрал, хоол, зөвлөгөө, асуултаа хуваалц.': 'Share your tips, food finds, and questions about saving money.',
  'Хувь нэмрийн чансаа': 'Contributor leaderboard',
  'Сүүлийн 30 хоног': 'Last 30 days',
  'Бүх цаг': 'All time',
  'Бүгдийг харах →': 'View all →',
  'Хувь нэмэр оруулагч одоогоор алга. Эхний болоорой!': 'No contributors yet. Be the first!',
  'Хувь нэмэр оруулагч одоогоор алга.': 'No contributors yet.',
  'Пост бичих': 'Write a post',
  'Одоогоор яриа алга.': 'No discussions yet.',
  'Эхний зөвлөгөөг та бичээрэй.': 'Be the first to write a tip.',
  'Уншиж байна…': 'Loading…',
  'Эрэлттэй': 'Trending',
  'Дуусах гэж': 'Expiring',
  'Хямд хоолны зөвлөгөө': 'Cheap food tips',
  'Үнэ өөрчлөгдсөн': 'Price changed',
  'Хошин': 'Humor',
  'Чөлөөт': 'General',
  'Оюутан': 'Student',
  'Оффис ажилтан': 'Office worker',
  'Санал хүсэлт': 'Feedback',
  'Цайны газар': 'Cafeteria',
  'Кофе/snack': 'Coffee/snack',
  '10k дотор lunch': 'Lunch under 10k',
  'Байрны олдвор': 'Local find',
  'Хөргөгч хоосон үед': 'Empty fridge',
  'Хөрөнгө оруулалт': 'Investing',
  'Болзоо': 'Dating',
  'Хямд үдийн хоол': 'Cheap lunch',
  'Гуанз олдвор': 'Cafeteria find',
  'Зөвлөмж': 'Tip',
  'шинэ': 'new',
  'засвар': 'edits',
  'пост': 'posts',
  'Хуудаслалт': 'Pagination',
  'Тайлагнах': 'Report',
  'Холбоотой газар': 'Linked place',
  'Газрын зураг дээр': 'Show on map',
  'Сэтгэгдэл бичих…': 'Write a comment…',
  'Сэтгэгдэл бичих бол нэвтэрнэ үү.': 'Sign in to leave a comment.',
  'Эхний сэтгэгдлийг үлдээж, яриаг эхлүүлээрэй.': 'Be the first to comment and start the discussion.',
  'Пост олдсонгүй.': 'Post not found.',
  'Олдсонгүй.': 'Not found.',
  'Олдсонгүй': 'Not found',
  'Яриа руу буцах': 'Back to Talk',
  'Хувь нэмрийн чансаа · Lavlah Яриа': 'Contributor leaderboard · Lavlah Talk',
  'Lavlah нийгэмлэгийн шилдэг хувь нэмэр оруулагчид.': 'Top contributors of the Lavlah community.',
  'Газар, үнэ, баталгаа, тайлан зэрэг хувь нэмрээр чансаа гарна.': 'Ranked by places, prices, verifications, and reports contributed.',
  'Нийт оноо': 'Total score',
  'Засвар': 'Edits',
  'Итгэмжлэгдсэн': 'Trusted',
  'Агуулга': 'Body',
  'Дүүрэг (заавал биш)': 'District (optional)',
  'Газар холбох (заавал биш)': 'Link a place (optional)',
  'Дурдсан газраа холбовол уншигчид шууд олно.': 'Linking the mentioned place lets readers find it instantly.',
  'Болих': 'Cancel',
  'Нийтлэх': 'Publish',
  'Илгээж байна…': 'Submitting…',
  'Илгээж байна...': 'Submitting...',
  'Ангилал': 'Category',
  'Санал болгох сэдвүүд': 'Suggested topics',
  'Газрын нэрээр хайх…': 'Search by place name…',
  'Хайж байна…': 'Searching…',
  'Хасах': 'Remove',
  'Газар': 'Place',
  'Нэргүй': 'Untitled',
  'Гарчиг 4+ үсэг, агуулга 10+ үсэг байх ёстой.': 'Title needs 4+ characters and body needs 10+.',
  'Пост нийтлэгдлээ': 'Post published',
  'Сэтгэгдэл нэмэгдлээ': 'Comment added',
  'Зөрчлийг мэдэгдэх': 'Report a violation',
  'Тайлан илгээгдлээ. Баярлалаа.': 'Report submitted. Thank you.',
  'Дэлгэрэнгүй (заавал биш)': 'Details (optional)',

  // ===== Uram (Deals) =====
  'Урам · Хямд хоол хайх': 'Deals · Find cheap food',
  'Хямд хоол, hot deal-ыг нэг дороос — Lavlah дээр.': 'Cheap food and hot deals in one place — on Lavlah.',
  'Хоолны хямдрал, урам-уудыг олон нийтээр хуваалцъя.': 'Share food deals and discounts with the community.',
  'AI боловсруулсан мэдээлэл — баталгаажуулна уу.': 'AI-processed information — please verify.',
  'Урам нэмэх': 'Add deal',
  'Урам нэмэгдлээ': 'Deal added',
  'Урам нэмэхийн тулд эхлээд нэвтэрнэ үү.': 'Sign in first to add a deal.',
  'Урилгын / аффилиэт линк зөвшөөрөгдөхгүй.': 'Invite / affiliate links are not allowed.',
  'Урилгын линк оруулахгүй.': 'Do not include invite links.',
  'Дуусах огноо өнгөрсөн байна.': 'Expiry date is in the past.',
  'Дуусах огноо мэдэхгүй бол хоосон үлдээж болно.': 'Leave blank if the expiry is unknown.',
  'Гарчиг хэт богино.': 'Title is too short.',
  'Урам руу буцах': 'Back to Deals',
  'Гол нөхцөлөө л бичээрэй. Урилгын линк оруулахгүй.': 'Just write the key terms. No invite links.',
  'Нэвтэрсний дараа л урам нэмэх боломжтой.': 'You can add deals only after signing in.',
  'Тэмдэглэл': 'Note',
  'Газар эсвэл бренд': 'Place or brand',
  'Хэрэв газрын зураг дээр байгаа газартай холбогдвол хайгаад сонгоно уу.': 'If linked to a place on the map, search and select it.',
  'Хямдарсан үнэ ₮': 'Discounted price ₮',
  'Хуучин үнэ ₮': 'Original price ₮',
  'Линк (заавал биш)': 'Link (optional)',
  'Зураг (≤5)': 'Photos (≤5)',
  'Гол нөхцөлөө л бичээрэй. Ашигтай бол дэмж, хүчингүй бол бууруул.': 'Just share the key terms. Upvote if useful, downvote if not.',
  'Өнөөдөр урам цөөн байна.': 'Few deals today.',
  'Эхний хямдралыг та нэмээрэй.': 'Be the first to post a deal.',
  'Эх сурвалж': 'Source',
  'Хоолны хямдрал': 'Food discount',
  'Кафе урам': 'Cafe deal',
  '1+1': '1+1',
  'Комбо': 'Combo',
  'Оюутны урам': 'Student deal',
  'Хүргэлтийн урам': 'Delivery deal',
  'Дэлгүүрийн хоол': 'Store food',
  'Дижитал купон': 'Digital coupon',
  'Хоол': 'Food',
  'Гэр ахуй': 'Household',
  'Дижитал': 'Digital',
  'Гоо сайхан': 'Beauty',
  'Хувцас': 'Fashion',
  'Хүүхэд': 'Kids',
  'Аялал': 'Travel',
  'Хямдрал мэдээ': 'Discount news',

  // ===== Place forms / share / report / filter / list / ranking =====
  'Нэр, нэг гол хоол, үнэ, зураг байхад хангалттай.': 'A name, one main dish, a price, and a photo are enough.',
  'Олон нийтийн мэдээлэл нэмэх горим': 'Community contribution mode',
  'Нэмэгч': 'Contributor',
  'Нэвтэрсний дараа газар нэмэх боломжтой.': 'You can add a place after signing in.',
  'Байршил': 'Location',
  'Газрын зураг холбоос (заавал биш)': 'Map link (optional)',
  'Google Maps холбоос байвал оруулна уу': 'Paste a Google Maps link if you have one',
  'Газрын нэр': 'Place name',
  'Жишээ: Наран цайны газар': 'Example: Naran Cafe',
  'Төрөл (хамгийн бага 1, хамгийн их 3)': 'Type (1 minimum, 3 maximum)',
  'Сонгосон': 'Selected',
  'Онцлог (заавал биш)': 'Features (optional)',
  'Үүсгэх үед газрын онцлог болгон хадгална.': 'Saved as place features when created.',
  'Гол хоол / үйлчилгээ': 'Main dish / service',
  'Үнэ (₮)': 'Price (₮)',
  'Жишээ: Цуйван': 'Example: Tsuivan',
  'Санамж': 'Note',
  'Гол хоол эсвэл хамгийн түгээмэл үйлчилгээний үнийг оруулна уу. Илгээсэн мэдээлэл нягталсны дараа баталгаажна.': 'Enter the price of the main dish or most common service. Submitted info is verified before being published.',
  'Буруу, давхардсан, зар сурталчилгааны шинжтэй мэдээллийг устгаж болно.': 'Wrong, duplicate, or promotional content may be removed.',
  'Цагийн хуваарь (заавал биш)': 'Hours (optional)',
  'Жишээ: Ажлын өдөр 10:00–20:00': 'Example: Weekdays 10:00–20:00',
  'Тэмдэглэл (заавал биш)': 'Note (optional)',
  'Жишээ: Порц сайтай, ганцаараа суухад тохиромжтой.': 'Example: Good portion, suitable for solo dining.',
  'Зоогийн газар, хоолны эсвэл хоолны баримт': 'Place, food, or receipt photo',
  'Зураг нэмбэл бусад хүн хурдан итгэнэ.': 'Adding a photo helps others trust the entry faster.',
  'Баримт': 'Receipt',
  'Хамгийн ихдээ 3 төрөл сонгоно.': 'Choose at most 3 types.',
  'Байршил тэмдэглэгдлээ.': 'Location saved.',
  'Зураг нэмэгдлээ': 'Photo added',
  'Баримт нэмэгдлээ': 'Receipt added',
  'Зураг устгах': 'Remove photo',
  'Баримт устгах': 'Remove receipt',
  'Хуулахад алдаа гарлаа': 'Upload failed',
  '5MB-аас бага байх ёстой': 'Must be less than 5MB',
  'Зураг оруулахын тулд эхлээд нэвтэрнэ үү.': 'Sign in first to upload a photo.',
  'Газар нэмэхийн тулд эхлээд нэвтэрнэ үү.': 'Sign in first to add a place.',
  'Газрын нэр шаардлагатай': 'Place name is required',
  'Хамгийн багадаа 1 төрөл сонгоно уу': 'Choose at least 1 type',
  'Хамгийн ихдээ 3 төрөл сонгоно': 'Choose at most 3 types',
  'Гол хоолны нэр шаардлагатай': 'Main dish name is required',
  'Үнэ шаардлагатай': 'Price is required',
  'Үнэ зөв тоо байх ёстой': 'Price must be a valid number',
  'Үнэ хэт бага байна': 'Price is too low',
  'Үнэ хэт өндөр байна. Дахин шалгана уу.': 'Price seems too high. Please double-check.',
  'Илгээхэд алдаа гарлаа': 'Submission failed',
  'Мэдээлэл илгээгдлээ. Нягталсны дараа газрын зураг дээр баталгаажна.': 'Submission received. It will appear on the map after verification.',
  'Хоолны төрөл сонгох': 'Choose food type',
  '1–3 төрөл сонгоно уу.': 'Choose 1–3 types.',
  'Хэрэглэх': 'Apply',
  'Хамгийн багадаа 1 төрөл': 'At least 1 type',

  // Filter sheet
  'Юу идмээр байна?': 'What do you feel like eating?',
  'Үнэ, хоолны төрөл, дүүргээр хурдан шүүнэ.': 'Quickly filter by price, food type, and district.',
  'Өөрөө тохируулах': 'Custom range',
  'Олон нийтийн илгээсэн хамгийн хямд хоолны үнэ.': 'Cheapest dish price submitted by the community.',
  'Хоолны төрөл': 'Food type',
  'Дүүрэг': 'District',
  'Шошго': 'Tags',
  'Жишээ: QPay, НӨАТ, Зогсоолтой.': 'Example: QPay, VAT, Parking.',
  'Үр дүн харах': 'Show results',
  'Үр дүн харах…': 'Loading results…',
  '5,000₮ хүртэл': 'Up to 5,000₮',
  '5,000–8,000₮': '5,000–8,000₮',
  '8,000–12,000₮': '8,000–12,000₮',
  '12,000₮+': '12,000₮+',
  'Зөвхөн ажиллаж байгаа газрууд.': 'Only currently open places.',

  // List sheet
  'Газрын зургийн үр дүнг жагсаалтаар үзэх.': 'View map results as a list.',
  'Цэвэрлэх бүгд': 'Clear all',
  'Дүүрэг:': 'District:',

  // Ranking / Top savings
  'Онооны тайлбар': 'Score explanation',
  'Оноо = үнийн боломж + олон нийтийн санал + баталгаажилт + сүүлд шинэчлэгдсэн + зураг нотолгоо − гомдол.': 'Score = price value + community votes + verification + freshness + photo evidence − complaints.',
  'Олон хүний баталгаажуулсан үнэ цэнтэй хоолны газрууд.': 'Value places confirmed by many people.',
  'Чансаа бүрдэж байна.': 'Leaderboard is filling up.',
  'Эхний баталгаажсан газрыг та нэмээрэй.': 'Be the first to add a verified place.',
  'Бүх жагсаалт харах →': 'View full list →',
  'Хадгаллаа. Дараа нь шууд олно.': 'Saved. You can find it later.',
  'Хадгалснаас хасах': 'Remove from saved',
  'Маршрут': 'Route',
  'Байршил тодорхойгүй.': 'Location unknown.',

  // Place card / categories
  'Ресторан': 'Restaurant',
  'Фитнес': 'Fitness',
  'Сургалт': 'Tutoring',
  'Үйлчилгээ': 'Service',
  'Хамгийн хямд:': 'Cheapest:',
  'Хямд:': 'Cheap:',
  'Эх сурвалжтай': 'Has source',
  'Өнөөдөр': 'Today',
  'Өчигдөр': 'Yesterday',
  'долоо хоног': 'weeks',
  'хоног': 'days',
  'сар': 'months',
  'жил': 'years',

  // Place bottom sheet
  'Үйлдэл': 'Actions',
  'Таалагдсан': 'Liked',
  'Нээлттэй': 'Open',
  'Хаалттай': 'Closed',
  'Шинэ бүртгэл': 'New entry',
  '7 хоногоос бага хугацаа өнгөрсөн тул мэдээлэл нягталгаа шаардлагатай.': 'Less than 7 days old — needs verification.',
  'Үнэ цэнтэй': 'Worth it',
  'Үнэ цэнэ бага': 'Not worth it',
  'Меню': 'Menu',
  'Илгээсэн': 'Submitted',
  'Зураг нэмэх': 'Add photo',
  'Нэвтэрсний дараа санал өгнө үү': 'Sign in to vote',
  'Газрын дэлгэрэнгүй': 'Place details',
  'Холбоос хуваалцах': 'Share link',
  'Газрын холбоосыг сошиал суваг руу хуваалцах': 'Share the place link to social channels',
  'Дамжуулах': 'Share via',
  'Системийн share…': 'System share…',
  'QR код үүсгэхэд алдаа гарлаа': 'Failed to generate QR code',
  'Холбоос хуулагдлаа': 'Link copied',
  'Холбоос хуулж чадсангүй': 'Failed to copy link',
  'Холбоос хуулах': 'Copy link',

  // Report wrong info / report dialog
  'Буруу мэдээлэл мэдэгдэх': 'Report wrong info',
  'Тань мэдээллийг бид шалгаад модератортой хамт шинэчилнэ.': 'We will review your report and update the info with our moderators.',
  'Юу буруу байна?': 'What is wrong?',
  'Хаяг / байршил буруу': 'Wrong address / location',
  'Цагийн хуваарь буруу': 'Wrong hours',
  'Хаагдсан / нүүсэн': 'Closed / moved',
  'Давхардсан газар': 'Duplicate place',
  'Жишээ: Үнэ 12,000₮ биш 15,000₮ болсон…': 'Example: Price is now 15,000₮ instead of 12,000₮…',
  'Баярлалаа! Бид 24 цагийн дотор шалгана.': 'Thank you! We will review within 24 hours.',
  'Бид 24 цагийн дотор шалгана.': 'We will review within 24 hours.',
  'Мэдэгдэх тулд эхлээд нэвтэрнэ үү.': 'Sign in first to report.',
  'Сесс дууссан байна. Дахин нэвтэрнэ үү.': 'Session expired. Please sign in again.',

  // Wrong price sheet
  'Үнэ шалгах хэрэгтэй': 'Price needs review',
  'Зөв мэдээллийг бөглөж туслаарай. Бид 24 цагт шалгана.': 'Help by filling in the correct info. We review within 24 hours.',
  'Хоолны нэр': 'Dish name',
  'Зөв үнэ (₮)': 'Correct price (₮)',
  'Зураг (заавал биш)': 'Photo (optional)',
  'Жишээ: 2 долоо хоногийн өмнө 11,000₮ болсон': 'Example: Became 11,000₮ two weeks ago',
  'Хоолны нэр болон зөв үнийг бөглөнө үү': 'Please fill in the dish name and correct price',
  'Баярлалаа! Үнийг 24 цагт шалгана.': 'Thank you! Price will be reviewed within 24 hours.',

  // Suggest edit / community board

  // Value vote sheet
  'Үнэ цэнтэй гэж үнэлэх': 'Mark as worth it',
  'Үнэ цэнэ багатай гэж үнэлэх': 'Mark as not worth it',
  'Шалтгаанаа сонгоно уу. Үнэ ≠ үнэ цэнэ — порц, шим тэжээл, чанар, амт, цатгалан байдлыг үнэлнэ.': 'Choose a reason. Price ≠ value — consider portion, nutrition, quality, taste, and how filling it is.',
  'Шалтгаанаа товч бичнэ үү': 'Briefly explain your reason',
  'Үнэ цэнтэй гэсэн санал хадгаллаа': 'Saved as worth it',
  'Үнэ цэнэ багатай гэсэн санал хадгаллаа': 'Saved as not worth it',
  'Порц сайн': 'Good portion',
  'Уурагтай': 'High protein',
  'Цатгалан': 'Filling',
  'Эрүүл талдаа': 'Healthy-leaning',
  'Амт сайн': 'Good taste',
  'Энэ бүсдээ хямд': 'Cheap for the area',
  'Порц бага': 'Small portion',
  'Шим тэжээл муу': 'Low nutrition',
  'Үнэ өндөр': 'Price too high',
  'Цатгалан биш': 'Not filling',
  'Мэдээлэл буруу': 'Wrong info',
  'Үнэ цэнэтэй үү?': 'Worth it?',

  // Verification badge
  'Олон нийт нэмсэн': 'Community-added',
  'Албан ёсны': 'Official',
  'Шалгагдаагүй': 'Unverified',
  'Шалгах шаардлагатай': 'Needs review',

  // Map / search interactions

  // Pagination labels
};

/** Lowercase lookup map built once. */
const LOWER_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(MN_TO_EN).map(([k, v]) => [k.toLowerCase(), v]),
);

export function lookupStatic(text: string): string | undefined {
  const trimmed = text.trim();
  if (!trimmed) return undefined;
  return MN_TO_EN[trimmed] ?? LOWER_MAP[trimmed.toLowerCase()];
}